import { useEffect, useState } from 'react';

const getInitialOnline = (): boolean => {
    if (typeof navigator === 'undefined') return true;
    return navigator.onLine;
};

/**
 * Tracks the browser's online status. Falls back to `true` during SSR.
 * Re-renders on `online` / `offline` events.
 */
export function usePwaOnlineStatus(): boolean {
    const [online, setOnline] = useState<boolean>(getInitialOnline);

    useEffect(() => {
        const handleOnline = () => setOnline(true);
        const handleOffline = () => setOnline(false);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return online;
}
